import { PermissionPage, TaskPage, LoginPage, NoAccessPage } from 'pages';
import { RouteObject } from 'react-router-dom';
import { SinglePane, PageLayout } from 'components/layouts';
import { TaskForm } from 'components/tasks/TaskForm';
import { RequireUser } from 'components/common';

const authRoutes: RouteObject = {
  path: '*',
  element: <SinglePane />,
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'forbidden',
      element: <NoAccessPage />,
    },
  ],
};

const ordinaryRoutes: RouteObject = {
  path: '*',
  element: <PageLayout />,
  children: [
    {
      index: true,
      element: <RequireUser allowedRoles={['SUPER_ADMIN', 'ADMIN']} />,
    },
    {
      path: 'permissions',
      element: <RequireUser allowedRoles={['SUPER_ADMIN']} />,
      children: [
        {
          path: '',
          loader: () => import('pages/PermissionPage'),
          element: <PermissionPage />,
        },
      ],
    },
    {
      path: 'tasks',
      element: <RequireUser allowedRoles={['SUPER_ADMIN', 'ADMIN']} />,
      children: [
        {
          index: true,
          loader: () => import('pages/TaskPage'),
          element: <TaskPage />,
        },
        {
          element: <TaskPage />,
          children: [
            {
              path: 'create',
              element: <TaskForm />,
            },
            {
              path: ':taskId',
              element: <TaskForm />,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <RequireUser allowedRoles={['SUPER_ADMIN', 'ADMIN']} />,
    },
  ],
};

const routes: RouteObject[] = [authRoutes, ordinaryRoutes];

export default routes;
